import React, { useEffect, useState } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../composant_reutilisable/useAuth";
import {
    FaBook,
    FaChartBar,
    FaCogs,
    FaExchangeAlt,
    FaTag,
    FaThLarge,
    FaUser
} from "react-icons/fa";
import axios from 'axios';
import Footer from "../../composant_reutilisable/footer";
import { FaMoneyBillTransfer } from "react-icons/fa6";

const Dashboard = () => {
    // ✅ TOUS LES HOOKS DOIVENT ÊTRE APPELÉS ICI, SANS CONDITION
    const { isLoading: authLoading, handleLogout } = useAuth();
    const navigate = useNavigate();
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showGlossary, setShowGlossary] = useState(false);
    
    // ✅ LOGS INITIAUX
    console.log("=========================================");
    console.log("🚀 DASHBOARD - CHARGEMENT");
    console.log("=========================================");
    
    // ✅ Récupération des données du localStorage
    const user_id = localStorage.getItem('userId');
    const groupe_id = localStorage.getItem('groupe_id');
    const token = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    
    // ✅ LOGS DU LOCALSTORAGE
    console.log("📦 CONTENU DU LOCALSTORAGE:");
    console.log("  - userId:", user_id);
    console.log("  - groupe_id:", groupe_id);
    console.log("  - access_token:", token ? `${token.substring(0, 50)}...` : "❌ NON TROUVÉ");
    console.log("  - refresh_token:", refreshToken ? `${refreshToken.substring(0, 50)}...` : "❌ NON TROUVÉ");
    console.log("  - user_nom:", localStorage.getItem('user_nom'));
    console.log("  - user_prenoms:", localStorage.getItem('user_prenoms'));
    console.log("  - user_email:", localStorage.getItem('user_email'));
    console.log("=========================================");
    
    // ✅ Vérification de la validité du token
    const checkTokenValidity = () => {
        if (!token) {
            console.error("❌ ERREUR: Aucun token d'accès trouvé dans le localStorage !");
            return false;
        }
        
        try {
            // Décoder le token pour vérifier l'expiration
            const parts = token.split('.');
            if (parts.length !== 3) {
                console.error("❌ ERREUR: Token JWT invalide (mauvais format)");
                return false;
            }
            
            const payload = JSON.parse(atob(parts[1]));
            const exp = payload.exp * 1000;
            const now = Date.now();
            
            console.log("🔐 INFORMATIONS DU TOKEN:");
            console.log("  - Expiration:", new Date(exp).toLocaleString());
            console.log("  - Temps restant:", Math.floor((exp - now) / 60000), "minutes");
            console.log("  - Token valide:", exp > now);
            
            if (exp <= now) {
                console.warn("⚠️ Le token a expiré !");
                return false;
            }
            
            return true;
        } catch (error) {
            console.error("❌ ERREUR lors du décodage du token:", error);
            return false;
        }
    };
    
    const tokenValid = checkTokenValidity();
    console.log("✅ Token valide:", tokenValid);
    
    // ✅ Gestion de l'absence de token
    useEffect(() => {
        console.log("🔄 useEffect - Vérification initiale");
        
        if (!token) {
            console.error("❌ Token non trouvé dans localStorage");
            setLoading(false);
            console.log("🚪 Redirection vers la page de connexion...");
            navigate('/');
            return;
        }
        
        if (!tokenValid) {
            console.error("❌ Token invalide ou expiré");
            setLoading(false);
            console.log("🚪 Redirection vers la page de connexion...");
            navigate('/');
            return;
        }
        
        if (!user_id || user_id === 'null' || !groupe_id || groupe_id === 'null') {
            console.error("❌ userId ou groupe_id manquants ou invalides");
            console.log("  - userId:", user_id);
            console.log("  - groupe_id:", groupe_id);
            setLoading(false);
            console.log("🚪 Redirection vers la page de connexion...");
            navigate('/');
            return;
        }
        
        if (user_id) {
            console.log("✅ Utilisateur identifié, chargement des accès...");
            document.title = "Transportpro | Accueil";
            fetchUserAccess();
        } else {
            console.warn("⚠️ Pas de userId, arrêt du chargement");
            setLoading(false);
        }
    }, []);
    
    const fetchUserAccess = async () => {
        
        
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_HOTE}/api/web/verifier-groupe/${user_id}/${groupe_id}/`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            
            console.log("✅ RÉPONSE API VERIFIER-GROUPE:");
            console.log("  - Status:", response.status);
            console.log("  - Data:", response.data);
            
            if (response.status === 200) {
                const data = response.data;
                let cleanedAccessArray = [];
                
                if (Array.isArray(data.acces)) {
                    cleanedAccessArray = data.acces.map((item) =>
                        item.acces
                            ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                            : []
                    ).flat();
                    
                    console.log("  - Accès nettoyés:", cleanedAccessArray);
                    setAccesGroupe(cleanedAccessArray);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                } else {
                    console.warn("⚠️ data.acces n'est pas un tableau:", data.acces);
                }
            }
        } catch (error) {
            console.error("=========================================");
            console.error("❌ ERREUR LORS DE LA RÉCUPÉRATION DES ACCÈS");
            console.error("  - Message:", error.message);
            console.error("  - Status:", error.response?.status);
            console.error("  - Data:", error.response?.data);
            console.error("=========================================");
            
            if (error.response?.status === 401) {
                console.error("🔒 Token non autorisé (401) - Nettoyage du localStorage...");
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('userId');
                localStorage.removeItem('groupe_id');
                localStorage.removeItem('user_nom');
                localStorage.removeItem('user_prenoms');
                localStorage.removeItem('user_email');
                localStorage.removeItem('accesGroupe');
                
                console.log("🚪 Redirection vers la page de connexion...");
                navigate('/');
            } else if (error.response?.status === 404) {
                console.error("❌ API non trouvée (404) - Vérifiez l'URL");
            } else if (error.code === 'ERR_NETWORK') {
                console.error("🌐 Erreur réseau - Vérifiez que le serveur backend est démarré");
            }
        } finally {
            console.log("🏁 FETCH USER ACCESS - FIN");
            setLoading(false);
        }
    };
    
    // Les éléments principaux du menu
    const menuItems = [
        {
            icon: <FaChartBar />,
            text: 'Rapport et statistique',
            link: '/Rapport-et-statistique',
            accessKey: 'Rapport_et_statistique'
        },
        {
            icon: <FaMoneyBillTransfer />,
            text: 'GIE',
            link: '/Parcs-GIE',
            accessKey: 'Gie'
        },
        {
            icon: <FaTag/>,
            text: 'Categorie évènement',
            link: '/Liste-categorie-evenement',
            accessCheck: () => true
        },
        {
            icon: <FaExchangeAlt />,
            text: 'Mise en file',
            link: '/Parcs',
            accessCheck: () => (
                accesGroupe.includes('Mise_en_file') ||
                accesGroupe.includes('Fret')
            )
        },
        {
            icon: <FaCogs />,
            text: 'Administration',
            link: '/Admin',
            accessCheck: () => true
        },
        {
            icon: <FaUser />,
            text: 'Mon Profil',
            link: '/Mon-profil',
            accessCheck: () => true
        },
        {
            icon: <FaBook />,
            text: 'Evénements',
            link: '/Liste-evenement',
            accessCheck: () => true
        }
    ];

    const handleClick = (lien) => {
        console.log("🖱️ Navigation vers:", lien);
        navigate(lien);
    };

    const shouldDisplayItem = (item) => {
        if (item.accessCheck) {
            return item.accessCheck();
        }
        return accesGroupe.includes(item.accessKey);
    };

    // Affichage du chargement
    if (loading) {
        console.log("⏳ Dashboard en cours de chargement...");
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Chargement...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    console.log("✅ Dashboard chargé avec succès!");
    console.log("  - Accès disponibles:", accesGroupe);
    console.log("  - Nombre d'éléments de menu:", menuItems.length);

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaThLarge size={25} className='mr-2' /> Accueil
                                </div>
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        Accueil
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (
                                shouldDisplayItem(item) && (
                                    <div key={index} className="col-md-2 mb-4">
                                        <div
                                            className="card rounded shadow-sm h-100"
                                            onClick={() => handleClick(item.getLink ? item.getLink() : item.link)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body d-flex flex-column align-items-center">
                                                <div className="mb-3 icon-medium" style={{ fontSize: '2rem' }}>
                                                    {item.icon}
                                                </div>
                                                <h5 className="text-center">
                                                    <Link
                                                        className='text-dark'
                                                        to={item.link}
                                                        style={{ textDecoration: 'none' }}
                                                    >
                                                        {item.text}
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;